module.exports = __webpack_public_path__ + "static/media/pms.f60ecb0c.png";